module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/kayak-37a3960b0c8fdb8552ff55a0bc8b4580.png";